import React from 'react';

import { type LineOrientation, Line } from './Line';

interface LinesProps {
  positions: number[];
  orientation: LineOrientation;
  isIdle: boolean;
}

export const Lines = ({ positions, orientation, isIdle }: LinesProps) => {
  const fromCenterIndexes = positions.map((_, index) =>
    Math.abs(index - Math.floor(positions.length / 2)),
  );

  return (
    <>
      {positions.map((position, index) => (
        <Line
          orientation={orientation}
          position={position}
          key={`${orientation}-${position}`}
          fromCenterIndex={fromCenterIndexes[index]}
          isIdle={isIdle}
        />
      ))}
    </>
  );
};
